import React, { useState } from 'react';
import '../Styles/Register.css';
import { FaChevronLeft } from "react-icons/fa";
import { getRegister } from '../Services/Operations/ProductAPI';
import { setLoginData, setSignupData,setToken,setuserId } from '../Redux/user_information';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate} from 'react-router';

const Register = () => {
    const dispatch=useDispatch();
    const navigatate=useNavigate();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({ name: '', email: '', phone: '', password: '' });

    const handleRegister = async () => {
        let hasError = false;
        let errorMessages = { name: '', email: '', phone: '', password: '' };
    
        if (!name) {
            errorMessages.name = 'Name is required';
            hasError = true;
        }
        if (!email) {
            errorMessages.email = 'Email is required';
            hasError = true;
        }
        if (!phone) {
            errorMessages.phone = 'Phone is required';
            hasError = true;
        }
        if (!password) {
            errorMessages.password = 'Password is required';
            hasError = true;
        }
    
        setErrors(errorMessages);
    
        if (!hasError) {
            //console.log('Register:', { name, email, phone, password });
            try {
                const formData = new FormData();
                formData.append("name", name);
                formData.append("email", email);
                formData.append("password", password);
                formData.append("phone", `+91${phone}`);
    
                const response = await getRegister(formData);
    
                if (response.success === true) {
                    //console.log("response register: ", response);
                    dispatch(setSignupData({
                        name,
                        email,
                        phone: `+91${phone}`
                    }));
                    dispatch(setToken(response.data.auth_token));
                    dispatch(setuserId(response.data.id))
                    navigatate("/")
                }
            } catch (error) {
                console.error("Error fetching registration details:", error);
            }
        }
    };
    

    return (
        <div className="register-container">
            <div style={{ backgroundColor: "#decccc", padding: "20px" }}>
                <button className="back-button"><FaChevronLeft /></button>
                <h2 className="register-heading">REGISTER</h2>
                <p className="register-subheading">Register now for free</p>
            </div>
            <div className="register-form">

                <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value);
                        if (e.target.value) {
                            setErrors({ ...errors, name: '' });
                        }
                    }}
                    className="register-input"
                />
                {errors.name && <p className="error-text">{errors.name}</p>}

                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        if (e.target.value) {
                            setErrors({ ...errors, email: '' });
                        }
                    }}
                    className="register-input"
                />
                {errors.email && <p className="error-text">{errors.email}</p>}

                <div className="phone-section">
                    <span className="phone-code">+91</span>
                    <input
                        type="tel"
                        placeholder="Phone"
                        value={phone}
                        onChange={(e) => {
                            setPhone(e.target.value);
                            if (e.target.value) {
                                setErrors({ ...errors, phone: '' });
                            }
                        }}
                        className="phone-input"
                    />
                </div>
                {errors.phone && <p className="error-text">{errors.phone}</p>}

                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        if (e.target.value) {
                            setErrors({ ...errors, password: '' });
                        }
                    }}
                    className="register-input"
                />
                {errors.password && <p className="error-text">{errors.password}</p>}

                <button onClick={handleRegister} className="register-button">REGISTER</button>

                <div className="login-section">
                    <span>Already have an account? </span>
                    <a href="/login" className="login-link">Login</a>
                </div>
            </div>
        </div>
    );
};

export default Register;
